import { AlertTriangle, Eye, Clock, XCircle, Shield, Zap, Target, Building, Users } from "lucide-react";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const SERVICES = [
  {
    id: "adempimenti",
    title: "Adempimenti",
    subtitle: "La Base Solida",
    tagline: "Zero pensieri, zero sorprese",
    description: "Contabilita, bilanci e fisco gestiti con precisione militare. Ogni scadenza sotto controllo, ogni numero al suo posto.",
    features: ["Contabilita sempre aggiornata", "Scadenze automatizzate", "Bilanci mensili chiari", "F24 senza sorprese"],
    image: "https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=800&q=80",
    color: "gold"
  },
  {
    id: "consulenza",
    title: "Consulenza Strategica",
    subtitle: "Il Passo Avanti",
    tagline: "Decisioni basate sui numeri",
    description: "Un CFO al tuo fianco. Analisi predittiva, controllo di gestione e pianificazione fiscale per crescere con consapevolezza.",
    features: ["Controllo di gestione", "Analisi predittiva", "Pianificazione fiscale", "Report mensili"],
    image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&q=80",
    color: "gold"
  },
  {
    id: "pannello",
    title: "Pannello Direzionale",
    subtitle: "Il Controllo Totale",
    tagline: "Tu al comando della tua azienda",
    description: "Il cruscotto digitale che trasforma i dati in decisioni. Riunioni guidate, verbali automatici, KPI in tempo reale.",
    features: ["Dashboard real-time", "Riunioni strutturate", "KPI personalizzati", "Decisioni data-driven"],
    image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=800&q=80",
    color: "netflix"
  }
];

export const PROBLEMS = [
  { icon: AlertTriangle, text: "F24 a sorpresa che ti mandano in crisi" },
  { icon: Eye, text: "Numeri incomprensibili che non riesci a leggere" },
  { icon: Clock, text: "Scadenze che scopri all'ultimo momento" },
  { icon: XCircle, text: "Decisioni prese a sentimento, non sui dati" }
];

export const SOLUTIONS = [
  { icon: Shield, text: "Tasse pianificate e conosciute con molti mesi di anticipo" },
  { icon: Eye, text: "Bilanci chiari che capisci al volo" },
  { icon: Zap, text: "Scadenze gestite senza il tuo intervento" },
  { icon: Target, text: "Ogni decisione supportata dai numeri" }
];

export const METHOD_STEPS = [
  { num: "01", title: "Mettiamo Ordine", desc: "Partiamo dai tuoi numeri reali e li rendiamo leggibili. Prima mettiamo ordine: fatturato, costi, voci che distorcono il risultato." },
  { num: "02", title: "Lettura Continua", desc: "Ti aiutiamo a leggere l'azienda mentre e in corsa, non solo a fine anno. Pochi indicatori, ma quelli che servono." },
  { num: "03", title: "Numeri alle Scelte", desc: "Colleghiamo i numeri alle decisioni: prezzi, mix vendita, costi da rivedere, attivita da spingere." },
  { num: "04", title: "Visibilita Fiscale", desc: "Ti diamo visibilita sull'impatto fiscale mentre l'anno va avanti, cosi pianifichi con anticipo." }
];

export const TESTIMONIALS_DATA = [
  { sector: "Impresa artigiana · passaggio da ditta individuale a SRL", quote: "Il passaggio mi spaventava e i numeri non erano chiari. Ho apprezzato la guida passo passo e le spiegazioni semplici. Oggi ho piu controllo su margini e punto di pareggio." },
  { sector: "Professionista con partita IVA · fase di riorganizzazione", quote: "Non sapevo che strada scegliere. Ho ricevuto un documento scritto con le opzioni ragionate sui miei numeri. Adesso ho chiaro quali sono le alternative e i passi da fare." },
  { sector: "Azienda di servizi · cercava un partner, non solo la contabilita", quote: "Mi servivano indicatori e scelte pratiche, non solo adempimenti. Ho trovato un affiancamento concreto oltre i numeri, con indicazioni operative. Il percorso e piu chiaro e sostenibile." },
  { sector: "Attivita commerciale al dettaglio", quote: "Facevo fatica a orientarmi tra spiegazioni troppo tecniche. Qui mi vengono spiegate in modo comprensibile. Capisco di piu e faccio meno confusione quando devo decidere." },
  { sector: "Piccola impresa con dipendenti", quote: "Mi sentivo poco accompagnato nelle decisioni. Ho trovato presenza, continuita e consigli pratici. Ho piu sicurezza nelle scelte e una gestione piu serena." },
  { sector: "SRL · riorganizzazione dei processi amministrativi", quote: "La gestione era faticosa e piena di attriti. Ho apprezzato puntualita, precisione e un modo di lavorare lineare. La gestione quotidiana e diventata piu facile." }
];

export const LOCATIONS = {
  main: { name: "Sede Legale", address: "Via Ponte Marino 41", city: "Ravenna" },
  meeting: { name: "Sala Riunioni", address: "Via Ponte Marino 43", city: "Ravenna" },
  others: ["Forli", "Cervia", "Roma", "Bari", "Cagliari"]
};

export const SOCIAL_LINKS = {
  facebook: "https://www.facebook.com/SilviaCasaliCommercialista",
  instagram: "https://www.instagram.com/sc_dottori_commercialisti/",
  linkedin: "https://www.linkedin.com/in/silvia-casali-7b96a937/"
};

export const WHATSAPP_NUMBER = "393290134945";
export const CONTACT_EMAIL = "assistenza@casalisilvia.com";

export const TEAM_ITEMS = [
  { icon: Building, title: "Uffici Amministrativi", desc: "Gestione documentale e contabilita quotidiana" },
  { icon: Users, title: "Team Consulenza", desc: "Analisi e supporto strategico personalizzato" },
  { icon: Target, title: "Area Direzionale", desc: "Controllo di gestione avanzato" }
];
